import styled from "styled-components";

const FlexibleSpacer = styled.div`
  flex-grow: 1;
`;

const DistinctSpacer = styled.div<{ width: number, height: number}>`
  width: ${props => props.width}px;
  height: ${props => props.height}px;
`;

export {FlexibleSpacer, DistinctSpacer};